import React, { useState, useMemo } from "react";

export const WebinarContext = React.createContext();

function WebinarProvider({ children }) {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(false);

  const value = useMemo(
    () => ({
      config,
      setConfig,
      loading,
      setLoading,
    }),
    [config, loading, setConfig],
  );

  return (
    <WebinarContext.Provider value={value}>{children}</WebinarContext.Provider>
  );
}

export default WebinarProvider;
